module.exports = __webpack_public_path__ + "img/ttshop_all.29ec06d6.svg";